/* Publish by EComposer at 2026-10-03 22:04:35*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mgaxxyj598"]=  window.__ectimmers["ecom-mgaxxyj598"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mgaxxyj598').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgaxxyj598', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vasrnvfe3nj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vasrnvfe3nj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ohv6x8eqop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ohv6x8eqop', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94q4udggw3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94q4udggw3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jdoj5t33ssg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jdoj5t33ssg', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ae3dz9gay8a"]=  window.__ectimmers["ecom-ae3dz9gay8a"] || {};
if(!this.$el)return!1;const t=this.$el,e=this,i=this.settings.animation,o=new CustomEvent("animation",function(){});let n=t.querySelector(".ecom__heading");n.querySelector("a")&&(n=n.querySelector("a")),n.addEventListener("animation",()=>{s()}),n.addEventListener("blur",function(r){r.target.dispatchEvent(o)});function s(){if(i==="typing"){let r=function(){setTimeout(function(){var b;let f=(b=g.settings)==null?void 0:b.animation;if(a.innerText=l[m].slice(0,c),d)if(c>l[m].length){d=!1,f=="typing"&&setTimeout(function(){r()},2e3);return}else c++;else c===0?(d=!0,m=(m+1)%l.length):c--;r()},d?120:60)},a=t.querySelector(".highlight-animation--typing");if(!a)return!1;let l=a.dataset.heading.split("|")||"",c=0,d=!0,m=0;const g=e;r()}if(i==="smooth"){let r=function(){let l=0,c= window.__ectimmers["ecom-ae3dz9gay8a"]["3ker5uxta"] = setInterval(function(){i!="smooth"&&clearInterval(c),l++,a.forEach((d,m)=>{l==a.length&&(l=0),m==l?d.classList.add("is-active"):d.classList.remove("is-active")})},3e3)},a=t.querySelectorAll(".heading-animation--smooth-item");if(!a)return!1;r()}}s()

                    });
                    
                        document.querySelectorAll('.ecom-ae3dz9gay8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ae3dz9gay8a', settings: {"animation":"smooth"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5un2cutrqf3"]=  window.__ectimmers["ecom-5un2cutrqf3"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-5un2cutrqf3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5un2cutrqf3', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjudqym49jq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjudqym49jq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}